export default function initHagerHofPopUp() {
    document.addEventListener('DOMContentLoaded', () => {
        const popup = document.querySelector('[data-popup]');

        if (popup) {
            if (localStorage.getItem('popup-seen') === 'true') {
                popup.style.display = 'none';
            } else {
                popup.style.display = 'flex';
                localStorage.setItem('popup-seen', 'true');
                const closePopup = document.querySelector('[data-close-popup]');

                closePopup.addEventListener('click', function () {
                    popup.setAttribute('data-popup', 'false');
                    document.querySelector('[data-popup]').style.display = this.value === 'false' ? 'flex' : 'none';
                });
            }
        }
    });
}
